var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-btn-toggle",
    {
      staticClass: "view-mode-toggle",
      attrs: { dense: "", mandatory: "" },
      model: {
        value: _vm.selected,
        callback: function($$v) {
          _vm.selected = $$v
        },
        expression: "selected"
      }
    },
    _vm._l(_vm.options, function(option) {
      return _c(
        "v-btn",
        {
          key: option.value,
          class: _vm.getButtonClasses(option),
          attrs: {
            value: option.value,
            small: "",
            disabled: _vm.disabled,
            title: option.title,
            "aria-label": option.title
          }
        },
        [
          _c(
            "v-icon",
            { staticClass: "view-mode-toggle__icon", attrs: { size: "20" } },
            [_vm._v(" " + _vm._s(option.icon) + " ")]
          )
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }